import { Activity } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ObsOverviewTab } from '@/components/observability/ObsOverviewTab';
import { ObsAreaTab } from '@/components/observability/ObsAreaTab';
import { ObsUserTab } from '@/components/observability/ObsUserTab';
import { ObsClaudeCodeTab } from '@/components/observability/ObsClaudeCodeTab';
import { ObsMCPTab } from '@/components/observability/ObsMCPTab';
import { ObsGeminiTab } from '@/components/observability/ObsGeminiTab';
import { ObsOptimizationTab } from '@/components/observability/ObsOptimizationTab';
import { ObsBedrockTab } from '@/components/observability/ObsBedrockTab';
import { ObsAwsTab } from '@/components/observability/ObsAwsTab';

export function ObservabilityPage() {
  const { t } = useTranslation();

  return (
    <div className="p-6 space-y-4 max-w-7xl mx-auto">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 shrink-0 mt-0.5">
          <Activity className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{t('observability.page.title')}</h1>
          <p className="text-muted-foreground text-sm mt-0.5">
            {t('observability.page.description')}
          </p>
        </div>
      </div>

      <Tabs defaultValue="overview" className="space-y-4">
        <TabsList className="w-full justify-start overflow-x-auto">
          <TabsTrigger value="overview">{t('observability.page.tab_overview')}</TabsTrigger>
          <TabsTrigger value="area">{t('observability.page.tab_area')}</TabsTrigger>
          <TabsTrigger value="user">{t('observability.page.tab_user')}</TabsTrigger>
          <TabsTrigger value="claude_code">{t('observability.page.tab_claude_code')}</TabsTrigger>
          <TabsTrigger value="mcp">{t('observability.page.tab_mcp')}</TabsTrigger>
          <TabsTrigger value="gemini">{t('observability.page.tab_gemini')}</TabsTrigger>
          <TabsTrigger value="optimization">{t('observability.page.tab_optimization')}</TabsTrigger>
          <TabsTrigger value="bedrock">{t('observability.page.tab_bedrock')}</TabsTrigger>
          <TabsTrigger value="aws">{t('observability.page.tab_aws')}</TabsTrigger>
        </TabsList>

        <TabsContent value="overview"><ObsOverviewTab /></TabsContent>
        <TabsContent value="area"><ObsAreaTab /></TabsContent>
        <TabsContent value="user"><ObsUserTab /></TabsContent>
        <TabsContent value="claude_code"><ObsClaudeCodeTab /></TabsContent>
        <TabsContent value="mcp"><ObsMCPTab /></TabsContent>
        <TabsContent value="gemini"><ObsGeminiTab /></TabsContent>
        <TabsContent value="optimization"><ObsOptimizationTab /></TabsContent>
        <TabsContent value="bedrock"><ObsBedrockTab /></TabsContent>
        <TabsContent value="aws"><ObsAwsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
